import React, { FC, PropsWithChildren } from 'react';
import { styled } from 'linaria/react';
import { infoBannerBackgroundColorsByVariant, infoBannerIconColorsByVariant, infoBannerSizes, infoBannerTextSizes, infoBannerVariants } from '@shared/config/components/infoBanner';
import { Text } from '@shared/ui/atoms';
import { InfoIcon } from '@shared/assets/icons';
import { baseColors } from '@shared/lib/theme';
type SizeValue = keyof typeof infoBannerSizes;
type ResponsiveSize = SizeValue | {
  mobile: SizeValue;
  desktop: SizeValue;
};
interface InfoBannerProps {
  size?: ResponsiveSize;
  variant?: keyof typeof infoBannerVariants;
}
const InfoBanner: FC<PropsWithChildren<InfoBannerProps>> = ({
  size = 'l',
  variant = 'purple',
  children
}) => {
  const desktopSize = typeof size === 'object' ? size.desktop || 'l' : size || 'l';
  const mobileSize = typeof size === 'object' ? size.mobile || desktopSize : size || 'l';
  return <InfoBannerWrapper variant={variant}>
      <IconWrapper variant={variant}>
        <InfoIcon />
      </IconWrapper>
      <Text family="MTSCompact" size={{
      desktop: infoBannerTextSizes[desktopSize],
      mobile: infoBannerTextSizes[mobileSize]
    }} weight="medium">
        {children}
      </Text>
    </InfoBannerWrapper>;
};
export default InfoBanner;
type InfoBannerWrapperProps = Required<Pick<InfoBannerProps, 'variant'>>;
const _exp = /*#__PURE__*/() => ({
  variant
}) => infoBannerBackgroundColorsByVariant[variant];
const InfoBannerWrapper = /*#__PURE__*/styled('div')({
  name: "InfoBannerWrapper",
  class: "i1yl477m",
  propsAsIs: false,
  vars: {
    "i1yl477m-0": [_exp()]
  }
});
type IconWrapperProps = Required<Pick<InfoBannerProps, 'variant'>>;
const _exp2 = /*#__PURE__*/() => ({
  variant
}) => infoBannerIconColorsByVariant[variant];
const IconWrapper = /*#__PURE__*/styled('div')({
  name: "IconWrapper",
  class: "imo7x4w",
  propsAsIs: false,
  vars: {
    "imo7x4w-0": [_exp2()]
  }
});

require("./InfoBanner.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./InfoBanner.tsx");